import React, { useEffect, useState, useContext, useRef } from 'react'
import { Table, Button, Popover, Input, Row, Col, Divider, message } from 'antd'
import { useReactToPrint } from 'react-to-print'
import { useHistory } from 'react-router'
import { MoreOutlined } from '@ant-design/icons/lib/icons'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import ProjectListModal from './ProjectListModal'
import PosSrc from '../../PosSrc'
import { Context, useStore } from '../../../../context'
import { ProjectCartaFactura } from '../project/ProjectCartaFactura'
import Utils from '../../../../utils/Utils'
import inventorySrc from '../../../inventory/inventorySrc'

const { Search } = Input

function ProjectListIndex(props) {
  const [state] = useContext(Context)
  const { hasPermissions } = useStore(state)
  const [loading, setLoading] = useState(false)
  const [nextPage, setNextPage] = useState('')
  const [dataSource, setDataSource] = useState([])
  const [existMoreInfo, setExistMoreInfo] = useState(false)
  const [visible, setVisible] = useState(false)
  const [infoRow, setInfoRow] = useState({})
  const [flag, setFlag] = useState(false)
  const [total, setTotal] = useState(0)
  const [getProject, setGetProjectShow] = useState({})
  const [allTurnos, setAllTurnos] = useState(true)

  const history = useHistory()

  useEffect(() => {
    if (props.activeKey === '8') {
      fetchProjectsList(props.store.id)
      props.setQuotationData({})
    }
    // eslint-disable-next-line
  }, [props.activeKey])

  // eslint-disable-next-line
  useEffect(() => { handlePrint() }, [flag])

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  },);

  const colorStatus = (text) => {
    switch (text) {
      case 'CONFIRMED':
        return 'var(--tendero-green)'

      case 'REJECTED':
        return 'red'

      default:
        return 'grey'
    }
  }

  const columns = [
    {
      title: 'Proyecto',
      dataIndex: 'invoice', // Field that is goint to be rendered
      render: text => <span style={{ textAlign: 'left' }}>{text}</span>,
    },
    {
      title: 'Cliente',
      dataIndex: 'client_id', // Field that is goint to be rendered
      render: text => <span>{`${text}`}</span>,
    },
    {
      title: 'Monto',
      dataIndex: 'total', // Field that is goint to be rendered
      render: text => <span>{text}</span>,
    },
    {
      title: 'Status',
      dataIndex: 'status', // Field that is goint to be rendered
      render: text => <span style={{ color: colorStatus(text) }} >{text}</span>,
    },
    {
      align: 'right',
      title: '',
      dataIndex: 'key', // Field that is goint to be rendered
      render: (id, data) => (
        <span>
          {((hasPermissions([93])) && data.status !== 'REJECTED' &&
            <Popover
              placement="left"
              content={
                <div>
                  {hasPermissions([93]) && data.status === 'PENDING' && (
                    <>
                      <span className={'user-options-items'} onClick={() => onEditConfirm(data, '1', id)}>
                        {'Facturar'}
                      </span>
                      <Divider className={'divider-enterprise-margins'} type={'horizontal'} />
                    </>
                  )}
                  {hasPermissions([95]) && data.status === 'PENDING' && (
                    <>
                      <span className={'user-options-items'} onClick={() => onEditConfirm(data, '7', id)}>
                        {'Editar'}
                      </span>
                      <Divider className={'divider-enterprise-margins'} type={'horizontal'} />
                    </>
                  )}
                  {/* {hasPermissions([96]) && data.status !== 'REJECTED' && data.status !== 'PENDING' && (
                    <>
                      <span className={'user-options-items'} onClick={() => onDelete(data)}>
                        {'Rechazar'}
                      </span>
                      <Divider className={'divider-enterprise-margins'} type={'horizontal'} />
                    </>
                  )} */}
                  {hasPermissions([93]) && (
                    <>
                      <span className={'user-options-items'} onClick={() => receiptToPrint(1, data)}>
                        {'Imprimir recibo'}
                      </span>
                    </>
                  )}
                </div>
              }
              trigger="click"
            >
              <Button shape={'circle'} className={'enterprise-settings-button'} id={`button-${id}`}>
                <MoreOutlined />
              </Button>
            </Popover>
          )}
        </span>
      ),
    },
  ]

  const fetchProjectsList = async (storeId, filter = '') => {
    setLoading(true)
    const excludeChars = Utils.excludedCharsContent(filter)
    try {
      const getAllClients = await PosSrc.getAllClients()

      let getProjects = null
      if (!allTurnos) {
        getProjects = await PosSrc.getProjectstAllTurns(storeId, state.turn.id, filter, excludeChars, 'desc')
      } else {
        getProjects = await PosSrc.getProjects(storeId, state.turn.id, filter, excludeChars, 'desc')
      }

      setDataSource(setProjects(getProjects, getAllClients.data))
      setExistMoreInfo(getProjects.data.next_page_url !== null)
      setNextPage(getProjects.data.next_page_url)
      setLoading(false)
    } catch (error) {

      console.log(error)
      message.error('Error al cargar los proyectos')
      setLoading(false)
    }
  }

  const setProjects = (projects, getAllClients) => {
    if (projects !== 'Too Many Attempts.') {
      let _projects = projects.data.data || []
      
      let projectsList = []
      _projects.forEach((d, i) => {
        let found = null
        if (getAllClients) {
          found = getAllClients.find(element => element.id === d.client_id);  
        }
        
        let clientName = 'Cliente final'

        if (found) {
          clientName = found.name
        }

        const obj = {
          key: i,
          id: d.id,
          client_id: clientName,
          total: d.total,
          invoice: d.project_invoice.invoice,
          status: d.status,
          expiration_date: d.expiration_date,
          destination_reason: d.destination_reason,
          origin_reason: d.origin_reason
        }

        projectsList.push(obj)
      });

      return projectsList
    } else {
      message.error('Se excedió el limte de peticiones, espera y recarga la aplicación')
    }
  }

  const onSearch = searchText => {
    fetchProjectsList(props.store.id, searchText)
  }

  const onDelete = data => {
    if (visible) {
      setLoading(true)
      PosSrc.projectDelete(infoRow.id)
        .then(res => {
          if (res?.errors && Object.keys(res.errors)?.length > 0) {
            setLoading(false)
            checkErrors(res)
          } else {
            message.success('Se ha eliminado el proyecto')
            // getCash(res.store_id)
            setLoading(false)
            setVisible(false)
            fetchProjectsList(props.store.id)
          }
        })
        .catch(err => {
          console.log(err)
          message.error('Error al eliminar el proyecto')
          setLoading(false)
        })

    } else {
      setVisible(true)
      setInfoRow(data)
    }
  }

  const onEditConfirm = async (data, key, id) => {
    document.getElementById(`button-${id}`).click()

    let getProject = null
    try {
      getProject = await PosSrc.getProject(data.id)

    } catch (err) {
      console.log(err)
      history.go(0)
      return false
    }

    const auxDate = new Date(data?.expiration_date)

    let birthday = auxDate
    let today = new Date()
    const x = parseInt((birthday - today))
    const day = (Math.ceil(x / (1000 * 60 * 60 * 24)));
    const products = getProject.project_details.map(item => {
      let discount_level = ''
      let discount_amount = 0

      item.presentation.discount_presentation.forEach(p => {
        if (item.discount_id === p.pivot.discount_id) {
          discount_level = p.discount_level
        
          discount_amount = parseFloat(p.pivot.discount_amount)
        }
      });

      const obj = {
        id: item.id,
        discount_id: item.discount_id,
        discount_amount: parseFloat(discount_amount),
        product: item.presentation.id,
        description: item.presentation.description,
        price: item.price,
        units: parseFloat(item.quantity),
        total: item.sub_total,
        type: item.presentation.presentation_combo_id ? 'COMBO' : 'PRESENTATION',
        discount_level: discount_level
      }

      return obj
    })

    const obj = {
      id: getProject.id,
      client: getProject.client,
      products: products,
      // quote_id: getProject.id,
      status: getProject.status,
      notes: getProject.notes,
      day: day,
      total: getProject.total,
      origin_reason: data.origin_reason,
      destination_reason: data.destination_reason,
      // discount_id: discount_id
    }

    props.setProjectData(obj)
    props.setActiveKey(key)
  }

  const checkErrors = res => {
    Object.keys(res.errors).map(key => {
      return message.error(res.errors[key])
    })
  }

  const handlerMoreButton = () => {
    setExistMoreInfo(false)
    if (existMoreInfo) {
      setLoading(true)
      PosSrc.getNextPage(nextPage).then(response => {
        setDataSource(dataSource.concat(setProjects(response)))
        setExistMoreInfo(response.data.next_page_url !== null)
        setNextPage(response.data.next_page_url)
        setLoading(false)
      })
    }
  }

  const receiptToPrint = async (key, projectShow) => {
    let getProject = null
    let SkusOptions = null

    try {
      getProject = await PosSrc.getProject(projectShow.id)
      SkusOptions = await inventorySrc.getSkusOptions()

    } catch (err) {
      console.log(err)
      history.go(0)
      return false
    }
    
    if (getProject.store.company.country.name === 'Honduras') {
      getProject.project_details.forEach(element => {
        SkusOptions.data.forEach(item => {
          if (element.presentation_id === item.presentation_id) {
            element.presentation_id = item.code
          }
        });
      });
    }

    setGetProjectShow(getProject)
    setTotal(key)
    setFlag(!flag)
  }

  const returnPrint = (key) => {
    switch (key) {
      case 1:
        return <ProjectCartaFactura ref={componentRef} getProject={getProject} />
      default:
        break;
    }
  }

  return (
    <>
      <Row gutter={16} style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h4 className={'section-space-list-bottom'}>Lista de proyectos</h4>
        <Button className="title-tendero new-button" onClick={() => props.newProject()}>
          {'Nuevo proyecto'}
        </Button>
      </Row>

      <div style={{ display: 'none' }}>{returnPrint(total)}</div>
      <Row gutter={16}>
        <Col xs={19} sm={19} md={19} lg={19}>
          <Search placeholder="Buscar por número de factura" className={'tendero-table-search custom-search'} size={'large'} onSearch={onSearch} />
        </Col>
        {/* {state.auth.role.id < 4  && ( */}
          <Col xs={5} sm={5} md={5} lg={5}>
            <Button className={allTurnos ? 'not-turnos new-deposit' : 'pay-receivable new-deposit'} onClick={() => setAllTurnos(!allTurnos)}>
              {allTurnos ? 'Turno actual' : 'Todos los turnos'}
            </Button>
          </Col>
        {/* )} */}
      </Row>
      <Table
        className={'CustomTableClass'}
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        loading={loading}
        rowKey={(record, index) => index}
      />
      <LoadMoreButton handlerButton={handlerMoreButton} moreInfo={existMoreInfo} />
      <ProjectListModal visible={visible} onDelete={onDelete} visibleStatus={status => setVisible(status)} />
    </>
  )
}

export default ProjectListIndex
